import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FaChalkboardTeacher, FaGraduationCap, FaHandshake } from 'react-icons/fa';

const ProfileSelection = () => {
  const navigate = useNavigate();

  const handleProfileSelection = (profileType) => {
    localStorage.setItem('userProfileType', profileType);

    if (profileType === 'apprenant') {
      navigate('/activation-page');
    }
    if (profileType === 'coach') {
      navigate('/activation-coach');
    }
    if (profileType === 'partenaire') {
      navigate('/Devenir-partenaire');
    }
  };

  const pageStyle = {
    backgroundColor: '#f5f7fa',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px'
  };

  const cardStyle = {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: '2px solid transparent',
    height: '100%'
  };

  const cardHoverStyle = {
    transform: 'translateY(-5px)',
    borderColor: '#1ab394',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
  };

  return (
    <div style={pageStyle}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <div className="text-center">
              <i className="fa fa-user-circle" style={{ fontSize: '60px', color: '#1ab394' }}></i>
              <h2 className="font-bold mt-3">Choisissez votre profil</h2>
              {/* <p className="text-muted">Sélectionnez le type de compte qui correspond à votre situation</p> */}
            </div>

            <Row>
              <Col md={4} className="mb-4">
                <Card
                  style={cardStyle}
                  className="h-100 text-center"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = '#1ab394';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'transparent';
                  }}
                  onClick={() => handleProfileSelection('apprenant')}
                >
                  <Card.Body className="d-flex flex-column">
                    <div className="">
                      <FaGraduationCap size={50} />
                    </div>
                    <Card.Title>Apprenant</Card.Title>
                    <Card.Text className="text-muted flex-grow-1 mb-0">
                      Je voudrais suivre des formations
                    </Card.Text>
                    <Button variant="primary" className="mt-0">Choisir</Button>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4} className="mb-4">
                <Card
                  style={cardStyle}
                  className="h-100 text-center"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = '#1c84c6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'transparent';
                  }}
                  onClick={() => handleProfileSelection('coach')}
                >
                  <Card.Body className="d-flex flex-column">
                    <div className="">
                      <FaChalkboardTeacher size={50} />
                    </div>
                    <Card.Title>Coach/Formateur</Card.Title>
                    <Card.Text className="text-muted flex-grow-1 mb-0">
                      Je souhaite animer des formations
                    </Card.Text>
                    <Button variant="success" className="mt-0">Choisir</Button>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4} className="mb-4">
                <Card
                  style={cardStyle}
                  className="h-100 text-center"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = '#f8ac59';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'transparent';
                  }}
                  onClick={() => handleProfileSelection('partenaire')}
                >
                  <Card.Body className="d-flex flex-column">
                    <div className="">
                      <FaHandshake size={50} />
                    </div>
                    <Card.Title>Partenaire</Card.Title>
                    <Card.Text className="text-muted flex-grow-1 mb-0">
                      Je représente une organisation partenaire
                    </Card.Text>
                    <Button variant="warning" className="mt-0">Choisir</Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            
            <div
              className="ibox-footer full-w mt-2 d-flex align-items-center justify-content-between pl-3 pr-3"
              style={{
                textAlign: 'center',
                width: '100%',
              }}
            >

              {/* Copyright */}
              <small>© {new Date().getFullYear()} <strong>Inovact</strong>. Tous droits réservés.</small>

              <div className="d-flex align-items-center justify-content-between">
                <small className="me-3 text-muted mr-2">Nous suivre</small>
                <div className="d-flex align-items-center gap-3">
                  <a href="https://www.facebook.com/inovact/" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="Facebook">
                    <i className="fa fa-facebook-f" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                  <a href="https://x.com/Inovact_Sarl" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="Twitter">
                    <i className="fa fa-twitter" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                  <a href="https://www.linkedin.com/company/inovact" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#4c4d4e10',
                      border: '1px solid #4c4d4e10',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#6c757d';
                      e.currentTarget.style.borderColor = '#6c757d';
                      e.currentTarget.querySelector('i').style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#4c4d4e10';
                      e.currentTarget.style.borderColor = '#4c4d4e10';
                      e.currentTarget.querySelector('i').style.color = '#6c757d';
                    }}
                    title="LinkedIn">
                    <i className="fa fa-linkedin" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSelection;